import packageJson from '../../package.json';

//Must be STAGING or PRODUCTION or DEVELOPMENT
const ENV = process.env.REACT_APP_ENV && ['STAGING', 'PRODUCTION', 'DEVELOPMENT'].includes(process.env.REACT_APP_ENV)
  ? process.env.REACT_APP_ENV
  : 'DEVELOPMENT';

const BACKEND_URL = ENV === 'STAGING'
  ? 'https://api.v3staging.imarketsmart.com/api'
  : ENV === 'PRODUCTION'
    ? 'https://api.app.imarketsmart.com/api'
    : 'http://localhost:8000/api';

const FRONTEND_URL = ENV === 'STAGING'
  ? 'https://v3staging.imarketsmart.com'
  : ENV === 'PRODUCTION'
    ? 'https://app.imarketsmart.com'
    : 'http://localhost:3000';

const GOOGLE_MAPS_KEY = "";//Public key for Google Maps API

// Function to get env
function isDev() {
  return ENV === 'DEVELOPMENT';
}

function isStaging() {
  return ENV === 'STAGING';
}

function isProduction() {
  return ENV === 'PRODUCTION';
}

const appVersion = packageJson.version;

export { ENV, BACKEND_URL, FRONTEND_URL, GOOGLE_MAPS_KEY, isDev, isStaging, isProduction, appVersion };

